import Modal from "components/Modal";

import { FormProvider } from "react-hook-form";
import { RadioCardGroup } from "components/RadioCardGroup";
import { DropdownFormProvider } from "components/DropdownFormProvider";
import Divider from "components/Divider";
import {
  ModalPrimaryButton,
  ModalSecondaryAction,
} from "pages/app/customer/AddFacility/AddFacilityModal";
import { useCreateOrUpdateSeparatorLogic } from "hooks/useCreateOrUpdateSeparatorLogic.hook";
import { AddSeparatorModal } from "pages/app/facility/AddSeparatorModal";
import { useQueryClient } from "@tanstack/react-query";
import { UppdragQueryKey } from "api/uppdrag.api";
import {
  CreateUppgiftLogicRetVal,
  TCreateInspectionSchema,
} from "./useCreateUppgiftLogic";
import { Separator } from "types/separator/separator.type";
import { Tips } from "components/Tips";

type Props = {
  logic: CreateUppgiftLogicRetVal;
};
export const CreateUppgiftModal = ({ logic }: Props) => {
  const queryClient = useQueryClient();

  const addSeparatorLogic = useCreateOrUpdateSeparatorLogic(
    logic.uppdrag.facility,
    (s: Separator) => {
      logic.form.setValue("separatorUuid", s.uuid);
      queryClient.invalidateQueries({ queryKey: [UppdragQueryKey.GetOne] });
    },
  );

  return (
    <Modal
      isOpen={logic.isModalOpen}
      title={"Ny aktivitet"}
      actionText="Spara"
      onClose={logic.onModalClose}
      afterClose={logic.afterModalClose}
      isLoading={logic.mutation.isPending}
      loadingText="Sparar..."
      hideButtons
    >
      <FormProvider {...logic.form}>
        <form className="mt-4 pt-4" onSubmit={logic.onSubmit}>
          <RadioCardGroup<TCreateInspectionSchema>
            name="inspectionType"
            label="Aktivitet"
            required
            items={logic.uppgiftDropdownItems}
            radioGroupClassName="grid grid-cols-1 gap-2"
          />

          <Divider className="my-4" />

          <DropdownFormProvider
            items={logic.separatorDropdownItems}
            label="Objekt"
            required={logic.isSeparatorRequired}
            name="separatorUuid"
            disabled={logic.separatorDropdownItems.length === 0}
            className="mb-6"
            onAddClick={addSeparatorLogic.openModal}
            addButtonText="Skapa nytt objekt"
            emptyText="Inga objekt"
          />
          {logic.isWaterMeasurementSelected && (
            <Tips
              id="create-uppgift-modal-watermeasurementpogint-is-required"
              paragraphs={[
                "För vattenprovtagning krävs ett objekt av typ Provtagningspunkt.",
              ]}
            />
          )}
          {logic.isTomningSelected && (
            <Tips
              id="create-uppgift-modal-separator-is-adviced"
              paragraphs={[
                "Kom ihåg att ange Objekt om du ska tömma en avskiljare, eftersom denna information kommer användas i objektets Driftjournal.",
              ]}
            />
          )}
          <AddSeparatorModal logic={addSeparatorLogic} />

          <Divider className="mb-4 mt-6" />
          <div className="flex justify-between gap-x-4">
            <ModalSecondaryAction onClick={logic.onModalClose} />
            <ModalPrimaryButton
              isLoading={logic.mutation.isPending}
              buttonText={logic.isTomningSelected ? "Nästa" : "Spara"}
            />
          </div>
          {/* </fieldset> */}
        </form>
      </FormProvider>
    </Modal>
  );
};
